import store from '../../store';
import { ServiceFunctions } from '@/wam/modules/service';
// 6LcrKscrAAAAAKK3REbTV7VyTxtY8YZBwro3JbeZ
class ClsGoogle {

  static f_getRecaptchaToken = function(recaptcha_key, action_name) {
    return new Promise((resolve) => {
      if (recaptcha_key) {
        grecaptcha.enterprise.ready(async () => {
          const token = await grecaptcha.enterprise.execute(recaptcha_key, {action: action_name});
          resolve(token);
        });
      } else {
        resolve('');
      }
    });
  };

}
export { ClsGoogle };
